// reducers/teamReducer.js

import { GET_TEAM_DETAILS_SUCCESS, DELETE_TEAM_SUCCESS } from "../actions/types";
import {
  ALL_TEAMS,
  LOGOUT,
  SELECTED_TEAM,
  SELECTED_CLOCK,
  IS_SHARED_ACCOUNT_SELECTED
} from '../actions/teamActions.js';

const INITIAL_STATE = {
  allTeams: [],
  selectedTeam: null,
};
const initialState = {
  teamData: null,
  loading: false,
  error: null,
  shouldRedirectTo: null,
};

const teamReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TEAM_DETAILS_SUCCESS:
      return {
        ...state,
        teamData: action.payload,
        loading: false,
        error: null,
      };
    case DELETE_TEAM_SUCCESS:
      return {
        ...state,
        teamData: null,
        loading: false,
        error: null,
      };
    case ALL_TEAMS:
      return { ...state, allTeams: action.payload };
    case SELECTED_TEAM:
      return { ...state, selectedTeam: action.payload };
    case SELECTED_CLOCK:
      return { ...state, selectedClock: action.payload };
    case IS_SHARED_ACCOUNT_SELECTED:
      return { ...state, shouldRedirectTo: "/selectaccount" };

    case LOGOUT:
      return INITIAL_STATE;
    default:
      return state;
  }


};

export default teamReducer;
